export default "__VITE_ASSET__DrOMn1mC__"